import { GET_EBLAST } from '../../constants';

const initialState = {
  data: {},
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case GET_EBLAST.LOAD:
      return {
        ...state,
        loading: true,
      };
    case GET_EBLAST.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case GET_EBLAST.FAIL:
      return {
        ...state,
        error: payload,
        loading: true,
      };
    default:
      return state;
  }
}
